export const FETCH_ORDERS = 'ACCOUNTS_MARKETPLACE/ORDERS_FETCH'
export const SET_FILTERS = 'ACCOUNTS_MARKETPLACE/ORDERS_SET_FILTERS'
export const SET_LOADING = 'ACCOUNTS_MARKETPLACE/ORDERS_SET_LOADING'
export const SET_DATA = 'ACCOUNTS_MARKETPLACE/ORDERS_DATA'
export const SET_SORTING = 'ACCOUNTS_MARKETPLACE/ORDERS_SET_SORTING'
export const DROP_DATA = 'ACCOUNTS_MARKETPLACE/ORDERS_DROP_DATA'
